import React, { useEffect, useState } from 'react';
import {
    getUploadedImagePath,
    useAppDispatch,
    useAppState
} from '@nutastic/nutastic-react-app';
import TabSlider, { TabSliderContent } from '../../refactor/tabs/TabSlider';
import { Swiper, SwiperSlide } from 'swiper/swiper-react.cjs';
import SwiperCore, { Autoplay, EffectFade, Navigation, Pagination } from 'swiper';
import { useNuStationData } from '../../hooks/useNuStationData';
import { useParams } from 'react-router-dom';
import { WebsiteActions } from '../../state/actions.mjs';
import ContentNotFoundPage from './ContentNotFoundPage';
import { ContentDescription } from '../ContentDetails';
import { RelatedContentTab } from '../ContentRelations';

SwiperCore.use([Navigation, Autoplay, EffectFade, Pagination]);

const coverSizeSwiperProps = {
    autoplay: {
        delay: 7500,
        disableOnInteraction: false,
        pauseOnMouseEnter: false
    },
    loop: true,
    slidesPerView: 1,
    direction: 'horizontal',
    effect: 'slide',
    pagination: {
        clickable: true
    }
};

const componentClass = 'contentPage';

const ContentArtistPage = () => {
    const appDispatch = useAppDispatch();
    const { isProcessing } = useAppState();
    const { getArtistBySlug } = useNuStationData();
    const [activeTab, setActiveTab] = useState(0);
    const [currentArtist, setCurrentArtist] = useState(null);
    const { id: contentId } = useParams();

    const {
        image: mainImage,
        title: name,
        excerpt: shortDescription,
        content: description,
        relatedArtists,
        relatedVideos,
        relatedMusic,
        image_1,
        image_2,
        image_3
    } = currentArtist || {};

    useEffect(() => {
        setCurrentArtist(null);
        appDispatch({ type: WebsiteActions.LOADING_PAGE_START });
        const fetchArtists = async () => {
            try {
                const selectedArtist = getArtistBySlug(contentId);
                setActiveTab(0);
                setCurrentArtist(selectedArtist);
                setTimeout(() => {
                    appDispatch({ type: WebsiteActions.LOADING_PAGE_DONE });
                }, 1000);
            } catch (e) {
                console.log('Failed to fetch artist information', e);
            }
        }
        fetchArtists();
    }, [contentId]);

    const tabs = currentArtist ? [
        { label: 'Details', key: 0, children: <ContentDescription description={description || 'No Description'} /> },
        { label: 'Related', key: 1, children: <RelatedContentTab artists={relatedArtists} videos={relatedVideos} music={relatedMusic} /> },
    ] : [ { key: 0, label: 'Loading', children: '...'} ]

    return (!!currentArtist && !isProcessing) ? <article className={componentClass}>
        <div className={`${componentClass}__header artistLayout`}>
            <div className={`${componentClass}__headerInfo artistLayout`}>
                <h1>{ name }</h1>
                { shortDescription && <p>{ shortDescription }</p> }
            </div>
            <Swiper className="artistSlideshow" { ...coverSizeSwiperProps }>
                <SwiperSlide><img src={getUploadedImagePath(mainImage)} alt={`${name} | NuStation.net`} className={`${componentClass}__artistImage`} /></SwiperSlide>
                { image_1 && <SwiperSlide><img src={getUploadedImagePath(image_1)} alt={`${name} | NuStation.net`} className={`${componentClass}__artistImage`} /></SwiperSlide> }
                { image_2 && <SwiperSlide><img src={getUploadedImagePath(image_2)} alt={`${name} | NuStation.net`} className={`${componentClass}__artistImage`} /></SwiperSlide> }
                { image_3 && <SwiperSlide><img src={getUploadedImagePath(image_3)} alt={`${name} | NuStation.net`} className={`${componentClass}__artistImage`} /></SwiperSlide> }
            </Swiper>
        </div>
        <div className={`${componentClass}__tabs`}>
            <TabSlider tabs={tabs} onChange={setActiveTab} activeKey={activeTab} />
            <div className="container">
                <TabSliderContent tabs={tabs} activeKey={activeTab} />
            </div>
        </div>
    </article>: <ContentNotFoundPage isProcessing={isProcessing} />;
};

export default ContentArtistPage;
